import { ROLES } from '../../constants/roles';

export const PHARMACY_COPY = {
  LAYOUT: {
    NAVBAR_BRAND: 'FUNTOA SMIE · Pharmacie',
    NAVBAR_BRAND_CENTRAL: 'FUNTOA SMIE · Pharmacie centrale',
    NAVBAR_BRAND_SITE: 'FUNTOA SMIE · Pharmacien site',
    TOPBAR_SECTION_CENTRAL: 'Pharmacie centrale',
    TOPBAR_SECTION_SITE: 'Pharmacien site',
    TOPBAR_TAGLINE: 'Pharmacie centralisée — stock, distribution & dispensation',
    TOPBAR_TAGLINE_CENTRAL: 'Pilotage central — achats, distributions, supervision multisites',
    TOPBAR_TAGLINE_SITE: 'Opérations site — dispensation, demandes d’approvisionnement, suivi local',
    SITE_SELECT_ARIA: 'Site de travail',
    SITE_CHIP_LABEL: 'Site',
    CHANGE_SITE_CHIP_TITLE: 'Changer le site de travail',
    CHANGE_SITE_MENU: 'Changer de site',
    NO_SITE_ASSIGNED: 'Aucun site assigné',
    SITE_GATE_BADGE: 'Ouverture de session pharmacie',
    SITE_GATE_TITLE: 'Choisir votre site de travail',
    SITE_GATE_DESC:
      'Sélectionnez le site pharmacie où vous travaillez maintenant. Stocks, dispensations, demandes d’appro et alertes utiliseront ce site pour cette session.',
    SITES_LOADING: 'Chargement des sites…',
    SITE_CARD_META_FALLBACK: 'Site pharmacie',
    SITE_CARD_CTA: 'Commencer',
    SITE_ACTIVE_TOAST: 'Site pharmacie actif : {name}',
    SITE_CENTRAL_SUFFIX: ' (centrale)',
    ACCOUNT_FALLBACK: 'Compte pharmacie',
    SIDE_MENU_SECTION: 'Pharmacie',
    SIDE_MENU_SECTION_CENTRAL: 'Pharmacie centrale',
    SIDE_MENU_SECTION_SITE: 'Pharmacien de site',
    SIDE_NEW_DISPENSATION: 'Nouvelle dispensation',
    LOGOUT: 'Déconnexion'
  },

  CATALOG: {
    BADGE: 'Référentiel',
    TITLE: 'Catalogue des médicaments',
    DESC: 'Référentiel produit partagé (médecins & pharmacie). Le stock est géré par lots séparément.',
    NEW_BUTTON: 'Nouveau médicament',
    SEARCH_PLACEHOLDER: 'Rechercher un médicament…',
    SEARCH_ARIA: 'Rechercher dans le catalogue',
    REFRESH_ARIA: 'Actualiser le catalogue',
    FILTER_CATEGORY_ALL: 'Toutes',
    FILTER_STATUS_ALL: 'Tous',
    FILTER_STATUS_ACTIVE: 'Actifs',
    FILTER_STATUS_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'médicaments',
    STAT_TOTAL: 'Au catalogue',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs / arrêtés',
    EMPTY_TITLE: 'Aucun médicament trouvé',
    EMPTY_HINT: 'Ajustez la recherche ou ajoutez un produit au référentiel.',
    EMPTY_CTA: 'Ajouter un médicament',
    COL_PRODUCT: 'Médicament',
    COL_CATEGORY: 'Catégorie',
    COL_UNIT: 'Unité',
    COL_MIN: 'Seuil min.',
    COL_PRICE: 'Prix (Ar)',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    EDIT: 'Modifier',
    MODAL_NEW_TITLE: 'Nouveau médicament',
    MODAL_EDIT_TITLE: 'Modifier le médicament',
    MODAL_NEW_DESC: 'Ajoutez un produit au référentiel partagé. Les lots de stock seront créés ensuite.',
    MODAL_EDIT_DESC: 'Mettez à jour la fiche produit. Le stock existant n’est pas modifié.',
    SECTION_IDENTITY: 'Identité produit',
    SECTION_SUPPLY: 'Approvisionnement',
    FIELD_NAME: 'Nom commercial / DCI',
    FIELD_NAME_HINT: 'Obligatoire — visible dans prescriptions et dispensations.',
    FIELD_DESC: 'Description',
    FIELD_DESC_HINT: 'Indications, présentation ou remarques utiles.',
    FIELD_CATEGORY: 'Catégorie',
    FIELD_UNIT: 'Unité de délivrance',
    FIELD_UNIT_HINT: 'Ex. comprimés, flacons, ampoules…',
    FIELD_MIN: 'Seuil minimum',
    FIELD_MIN_HINT: 'Alerte de stock bas sur les sites.',
    FIELD_PRICE: 'Prix unitaire (Ar)',
    FIELD_PRICE_HINT: 'Optionnel — utilisé pour la valorisation.',
    FIELD_STATUS: 'Statut catalogue',
    CANCEL: 'Annuler',
    SAVE: 'Enregistrer',
    SAVING: 'Enregistrement…',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif',
    STATUS_DISCONTINUED: 'Arrêté',
    NO_CATEGORY: 'Sans catégorie',
    NO_PRICE: '—'
  },

  DASHBOARD: {
    BADGE: 'Pilotage',
    TITLE: 'Tableau de bord',
    DESC_WITH_SITE: 'Vue d’ensemble de la pharmacie centrale — {name}.',
    DESC_NO_SITE: 'Aucune pharmacie principale configurée — désignez un site central.',
    REFRESH_ARIA: 'Actualiser le tableau de bord',
    ATTENTION_TITLE: 'Points d’attention',
    ATTENTION_HINT: '{n} élément(s) demandent une action aujourd’hui.',
    ATTENTION_OK: 'Rien d’urgent — le réseau est sous contrôle.',
    KPI_UNITS: 'Unités en stock',
    KPI_VALUE: 'Valeur stock',
    KPI_VALUE_HINT: 'Coût des lots',
    KPI_MEDS: 'Médicaments actifs',
    KPI_SITES: 'Sites actifs',
    KPI_STOCK_ALERTS: 'Alertes stock',
    KPI_STOCK_ALERTS_HINT: '{n} rupture(s)',
    KPI_EXPIRY_ALERTS: 'Alertes péremption',
    KPI_EXPIRY_ALERTS_HINT: '{n} périmé(s)',
    KPI_TODAY_DISPENSE: 'Délivrées aujourd’hui',
    KPI_MOVEMENTS: 'Mouvements du jour',
    SECTION_QUEUE: 'À traiter',
    SECTION_QUEUE_HINT: 'File opérationnelle — cliquez pour ouvrir.',
    SECTION_ALERTS: 'Alertes prioritaires',
    SECTION_ALERTS_HINT: 'Ruptures, stocks bas et péremptions.',
    SECTION_QUICK: 'Accès rapides',
    SEE_ALL_ALERTS: 'Toutes les alertes',
    EMPTY_ALERTS: 'Aucune alerte active.',
    EMPTY_ALERTS_HINT: 'Stock et péremptions sous contrôle.',
    QUEUE_ORDERS: 'Commandes à traiter',
    QUEUE_ORDERS_HINT: 'Brouillons & en attente',
    QUEUE_RECEIVE: 'À réceptionner',
    QUEUE_RECEIVE_HINT: 'Commandes validées',
    QUEUE_REQUESTS: 'Demandes d’appro',
    QUEUE_REQUESTS_HINT: '{n} urgente(s)',
    QUEUE_DISTRIBUTIONS: 'Distributions en cours',
    QUEUE_DISTRIBUTIONS_HINT: 'Préparation & envoi',
    QUEUE_DISPENSATIONS: 'Dispensations en attente',
    QUEUE_DISPENSATIONS_HINT: 'À finaliser',
    QUEUE_TODAY: 'Délivrées aujourd’hui',
    QUEUE_TODAY_HINT: 'Activité du jour',
    QUICK_DISPENSE: 'Dispensation',
    QUICK_DISPENSE_HINT: 'Délivrer une ordonnance',
    QUICK_REQUESTS: 'Demandes d’appro',
    QUICK_REQUESTS_HINT: 'Traiter les sites',
    QUICK_ALERTS: 'Alertes stock',
    QUICK_ALERTS_HINT: 'Ruptures & péremptions',
    QUICK_REPORTS: 'Rapports',
    QUICK_REPORTS_HINT: 'Consommation & perf.',
    QUICK_ORDERS: 'Commandes',
    QUICK_ORDERS_HINT: 'Achats fournisseurs',
    QUICK_MOVEMENTS: 'Mouvements',
    QUICK_MOVEMENTS_HINT: 'Traçabilité stock',
    QUICK_INVENTORY: 'Inventaire',
    QUICK_INVENTORY_HINT: 'Comptage physique',
    CTA_DISPENSE: 'Nouvelle dispensation',
    CTA_ORDERS: 'Commandes',
    HEALTH_OK: 'Sain',
    HEALTH_WATCH: 'À surveiller',
    HEALTH_CRITICAL: 'Critique'
  },

  DASHBOARD_SITE: {
    BADGE: 'Site',
    TITLE: 'Tableau de bord',
    DESC: 'Pilotage opérationnel — {name}.',
    NO_SITE: 'Sélectionnez un site de travail pour afficher votre tableau de bord.',
    REFRESH_ARIA: 'Actualiser le tableau de bord',
    KPI_UNITS: 'Unités en stock',
    KPI_MEDS: 'Médicaments suivis',
    KPI_LOW: 'Stocks bas',
    KPI_OUT: 'Ruptures',
    KPI_EXPIRING: 'Lots expirants',
    KPI_EXPIRED: 'Lots périmés',
    SECTION_QUEUE: 'À traiter sur ce site',
    SECTION_ALERTS: 'Alertes du site',
    SECTION_QUICK: 'Accès rapides',
    SEE_ALL: 'Tout voir',
    EMPTY_DISPENSE: 'Aucune dispensation en attente.',
    EMPTY_ALERTS: 'Aucune alerte sur ce site.',
    QUEUE_DISPENSE: 'Dispensations en attente',
    QUEUE_DISPENSE_HINT: 'À délivrer',
    QUEUE_REQUESTS: 'Demandes d’appro',
    QUEUE_REQUESTS_HINT: 'Approvisionner le site',
    QUEUE_STOCK: 'Stocks du site',
    QUEUE_STOCK_HINT: '{n} références',
    QUEUE_INVENTORY: 'Inventaire',
    QUEUE_INVENTORY_HINT: 'Comptage physique du site',
    QUICK_DISPENSE: 'Dispensation',
    QUICK_REQUESTS: 'Demandes d’appro',
    QUICK_STOCK: 'Stocks du site',
    QUICK_ALERTS: 'Alertes',
    QUICK_MOVEMENTS: 'Mouvements',
    QUICK_INVENTORY: 'Inventaire',
    QUICK_INVENTORY_HINT: 'Compter les lots',
    CTA_DISPENSE: 'Nouvelle dispensation',
    CTA_REQUESTS: 'Demandes d’appro',
    COL_NUMBER: 'N°',
    COL_PATIENT: 'Patient',
    COL_STATUS: 'Statut'
  },

  NAV: {
    dashboard: { label: 'Tableau de bord', hint: 'Vue d’ensemble & alertes', icon: 'home' },
    catalog: { label: 'Catalogue', hint: 'Médicaments & catégories', icon: 'pills' },
    centralStock: { label: 'Stock central', hint: 'Lots de la pharmacie principale', icon: 'warehouse' },
    dutyCabinet: { label: 'Armoire de garde', hint: 'Stock nurse / major sur le site central', icon: 'shield' },
    siteStocks: { label: 'Stocks par site', hint: 'Inventaire des sites secondaires', icon: 'building' },
    workSiteStock: { label: 'Stock du site', hint: 'Inventaire de votre site de travail', icon: 'warehouse' },
    inventories: { label: 'Inventaire', hint: 'Comptage physique des lots', icon: 'clipboard-list' },
    suppliers: { label: 'Fournisseurs', hint: 'Partenaires d’achat', icon: 'truck' },
    orders: { label: 'Commandes', hint: 'Achats fournisseurs & réception', icon: 'inbox' },
    requests: { label: 'Demandes appro', hint: 'Demandes des sites', icon: 'list' },
    distributions: { label: 'Distributions', hint: 'Centrale → sites', icon: 'arrowRight' },
    dispensations: { label: 'Dispensation', hint: 'Délivrance patients', icon: 'pills' },
    interactions: { label: 'Interactions', hint: 'Référentiel médicamenteux', icon: 'shield' },
    alerts: { label: 'Alertes', hint: 'Stock & péremption', icon: 'bell' },
    movements: { label: 'Mouvements', hint: 'Traçabilité du stock', icon: 'history' },
    reports: { label: 'Rapports', hint: 'Consommation & performance', icon: 'chartBar' }
  },

  STATUS: {
    // Commandes
    DRAFT: 'Brouillon',
    PENDING: 'En attente',
    VALIDATED: 'Validée',
    RECEIVED: 'Réceptionnée',
    CANCELLED: 'Annulée',
    // Demandes appro
    APPROVED: 'Approuvée',
    PARTIALLY_APPROVED: 'Partiellement approuvée',
    REJECTED: 'Rejetée',
    FULFILLED: 'Servie',
    // Distributions
    PREPARING: 'En préparation',
    SHIPPED: 'Expédiée',
    DELIVERED: 'Livrée',
    // Dispensation
    DISPENSED: 'Délivrée',
    // Inventaire
    COUNTING: 'En cours',
    CLOSED: 'Clôturé'
  },

  SEVERITY: {
    NONE: 'Aucune',
    MINOR: 'Mineure',
    MODERATE: 'Modérée',
    MAJOR: 'Majeure'
  },

  STOCK_STATUS: {
    OK: 'OK',
    LOW_STOCK: 'Stock bas',
    OUT_OF_STOCK: 'Rupture'
  },

  STOCK_CENTRAL: {
    BADGE: 'Stock central',
    TITLE: 'Stock de la pharmacie principale',
    DESC: 'Inventaire par lot (n° de lot + péremption). Les sorties suivent la logique FEFO.',
    NO_CENTRAL: 'Aucune pharmacie principale configurée. Désignez un site central pour gérer ce stock.',
    SITE_BADGE: 'Pharmacie principale',
    CTA_INVENTORY: 'Inventaire'
  },

  STOCK_SITES: {
    BADGE: 'Stocks par site',
    TITLE: 'Inventaire des sites',
    DESC: 'Inventaire réel par site : médicaments en stock (distribution ou réception), y compris l’armoire de garde.',
    BADGE_WORK: 'Stock site',
    TITLE_WORK: 'Stock de votre site',
    DESC_WORK: 'Inventaire du site de travail actif uniquement — pas de consultation multi-sites.',
    NO_SITE: 'Aucun site disponible.',
    NO_WORK_SITE: 'Sélectionnez un site de travail pour consulter le stock.',
    SITE_PICKER_ARIA: 'Site à consulter',
    CENTRAL_TAG: 'Centrale',
    DUTY_TAG: 'Garde',
    ADJUST_HINT: 'Ajustement des lots disponible sur ce site.',
    READONLY_HINT: 'Consultation seule — ajustement réservé à la pharmacie centrale.',
    DISTRIBUTED_HINT:
      'Références distribuées sur ce site — le catalogue complet n’est pas affiché ici.',
    DUTY_HINT:
      'Stock de l’armoire de garde uniquement (réassort depuis la pharmacie centrale). Les seuils min. du stock principal ne s’appliquent pas ici.',
    DUTY_EMPTY_HINT:
      'Aucun lot dans l’armoire de garde. Réapprovisionnez depuis la page Armoire de garde.',
    CTA_INVENTORY: 'Lancer un inventaire'
  },

  STOCK_TABLE: {
    SEARCH_PLACEHOLDER: 'Rechercher un médicament…',
    SEARCH_ARIA: 'Rechercher dans le stock',
    REFRESH_ARIA: 'Actualiser le stock',
    FILTER_ALL: 'Tous',
    FILTER_IN_STOCK: 'En stock',
    FILTER_LOW: 'Stock bas',
    FILTER_OUT: 'Ruptures',
    RESULTS_LABEL: 'références',
    STAT_SKUS: 'Références',
    STAT_UNITS: 'Unités disponibles',
    STAT_LOW: 'Stock bas',
    STAT_OUT: 'Ruptures',
    STAT_EXPIRING: 'Lot bientôt périmé',
    EMPTY_TITLE: 'Aucun stock trouvé',
    EMPTY_HINT: 'Ajustez les filtres ou vérifiez les réceptions de commandes / distributions.',
    EMPTY_HINT_SITE:
      'Aucune référence distribuée sur ce site. Le stock apparaîtra après une livraison depuis la pharmacie centrale.',
    COL_PRODUCT: 'Médicament',
    COL_ON_HAND: 'Disponible',
    COL_MIN: 'Seuil',
    COL_LOTS: 'Lots',
    COL_EXPIRY: 'Péremption proche',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Lots',
    SHOW_LOTS: 'Voir lots',
    HIDE_LOTS: 'Masquer',
    LOTS_LOADING: 'Chargement des lots…',
    LOTS_EMPTY: 'Aucun lot actif pour ce médicament sur ce site.',
    LOT_NUMBER: 'N° lot',
    LOT_EXPIRY: 'Péremption',
    LOT_QTY: 'Quantité',
    LOT_SOURCE: 'Source',
    LOT_ADJUST: 'Ajuster',
    FEFO_HINT: 'Sortie FEFO : le lot dont la date de péremption est la plus proche est prioritaire.',
    ADJUST_TITLE: 'Ajuster le lot',
    ADJUST_DESC: 'Corrigez la quantité disponible. Un motif est obligatoire pour la traçabilité.',
    ADJUST_QTY: 'Nouvelle quantité',
    ADJUST_QTY_HINT: 'Remplace la quantité actuelle du lot (pas un mouvement relatif).',
    ADJUST_REASON: 'Motif',
    ADJUST_REASON_HINT: 'Inventaire, casse, péremption retirée…',
    ADJUST_REASON_PLACEHOLDER: 'Décrivez la raison de l’ajustement',
    ADJUST_CANCEL: 'Annuler',
    ADJUST_SAVE: 'Enregistrer l’ajustement',
    ADJUST_SAVING: 'Enregistrement…',
    ADJUST_SUCCESS: 'Stock ajusté.',
    ADJUST_FAIL: 'Ajustement impossible.',
    CURRENT_QTY: 'Quantité actuelle',
    EXPIRY_EXPIRED: 'Périmé',
    EXPIRY_SOON: '≤ 60 j',
    EXPIRY_OK: 'OK'
  },

  SUPPLIERS: {
    BADGE: 'Partenaires',
    TITLE: 'Fournisseurs pharmacie',
    DESC: 'Partenaires d’achat pour les commandes de réapprovisionnement de la pharmacie centrale.',
    NEW_BUTTON: 'Nouveau fournisseur',
    SEARCH_PLACEHOLDER: 'Rechercher un fournisseur…',
    SEARCH_ARIA: 'Rechercher dans les fournisseurs',
    REFRESH_ARIA: 'Actualiser',
    FILTER_ALL: 'Tous',
    FILTER_ACTIVE: 'Actifs',
    FILTER_INACTIVE: 'Inactifs',
    RESULTS_LABEL: 'fournisseurs',
    STAT_TOTAL: 'Au référentiel',
    STAT_ACTIVE: 'Actifs',
    STAT_INACTIVE: 'Inactifs',
    EMPTY_TITLE: 'Aucun fournisseur',
    EMPTY_HINT: 'Ajoutez un partenaire pour créer des commandes d’achat.',
    EMPTY_CTA: 'Ajouter un fournisseur',
    COL_NAME: 'Fournisseur',
    COL_CONTACT: 'Contact',
    COL_PHONE: 'Téléphone',
    COL_EMAIL: 'Email',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    EDIT: 'Modifier',
    ACTIVATE: 'Activer',
    DEACTIVATE: 'Désactiver',
    DELETE: 'Supprimer',
    DELETE_CONFIRM: 'Supprimer le fournisseur « {name} » ? Cette action est irréversible.',
    DELETE_OK: 'Supprimé.',
    DELETE_FAIL: 'Suppression impossible.',
    STATUS_ACTIVE: 'Actif',
    STATUS_INACTIVE: 'Inactif',
    MODAL_NEW: 'Nouveau fournisseur',
    MODAL_EDIT: 'Modifier le fournisseur',
    MODAL_NEW_DESC: 'Renseignez l’identité et les coordonnées du partenaire d’achat.',
    MODAL_EDIT_DESC: 'Mettez à jour la fiche fournisseur.',
    SECTION_IDENTITY: 'Identité',
    SECTION_CONTACT: 'Coordonnées',
    FIELD_NAME: 'Raison sociale',
    FIELD_NAME_HINT: 'Obligatoire — visible sur les commandes.',
    FIELD_CONTACT: 'Personne de contact',
    FIELD_PHONE: 'Téléphone',
    FIELD_EMAIL: 'Email',
    FIELD_ADDRESS: 'Adresse',
    FIELD_NOTES: 'Notes internes',
    CANCEL: 'Annuler',
    SAVE: 'Enregistrer',
    SAVING: 'Enregistrement…',
    SAVE_OK: 'Enregistré.',
    SAVE_FAIL: 'Échec.'
  },

  ORDERS: {
    BADGE: 'Achats',
    TITLE: 'Commandes fournisseurs',
    DESC: 'Réapprovisionnement de la pharmacie centrale. Réception par lot (n° + date de péremption).',
    NEW_BUTTON: 'Nouvelle commande',
    SEARCH_PLACEHOLDER: 'Rechercher n° ou fournisseur…',
    SEARCH_ARIA: 'Rechercher une commande',
    REFRESH_ARIA: 'Actualiser les commandes',
    FILTER_ALL: 'Toutes',
    RESULTS_LABEL: 'commandes',
    STAT_TOTAL: 'Commandes',
    STAT_OPEN: 'En cours',
    STAT_RECEIVED: 'Réceptionnées',
    STAT_AMOUNT: 'Montant affiché',
    EMPTY_TITLE: 'Aucune commande',
    EMPTY_HINT: 'Créez une commande fournisseur pour réapprovisionner le stock central.',
    EMPTY_CTA: 'Créer une commande',
    COL_NUMBER: 'N° commande',
    COL_SUPPLIER: 'Fournisseur',
    COL_LINES: 'Lignes',
    COL_AMOUNT: 'Montant',
    COL_EXPECTED: 'Livraison prévue',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    OPEN: 'Ouvrir',
    NEXT_DRAFT: 'À soumettre',
    NEXT_PENDING: 'À valider',
    NEXT_VALIDATED: 'À réceptionner',
    NEXT_RECEIVED: 'Terminée',
    NEXT_CANCELLED: 'Annulée',
    CREATE_TITLE: 'Nouvelle commande fournisseur',
    CREATE_DESC:
      'Choisissez le fournisseur et ajoutez des médicaments via la recherche (quantités suggérées depuis le stock central).',
    SECTION_HEADER: 'En-tête',
    SECTION_LINES: 'Lignes de commande',
    FIELD_SUPPLIER: 'Fournisseur',
    FIELD_SUPPLIER_HINT: 'Optionnel — utile pour le suivi d’achat.',
    FIELD_EXPECTED: 'Date prévue',
    FIELD_NOTES: 'Notes',
    LINES_COUNT: '{n} ligne(s)',
    TOTAL_LABEL: 'Total estimé',
    LINE_TOTAL: 'Sous-total',
    DRAFT: 'Brouillon',
    SUBMIT: 'Soumettre',
    CANCEL: 'Annuler',
    SAVING: 'Enregistrement…',
    BACK_TO_LIST: 'Retour aux commandes',
    RESULTS_LINES: 'lignes',
    DETAIL_SUPPLIER: 'Fournisseur',
    DETAIL_SITE: 'Réception (centrale)',
    DETAIL_EXPECTED: 'Livraison prévue',
    DETAIL_AMOUNT: 'Montant',
    DETAIL_NOTES: 'Notes',
    FLOW_TITLE: 'Cycle de vie',
    FLOW_DRAFT: 'Brouillon',
    FLOW_PENDING: 'Soumise',
    FLOW_VALIDATED: 'Validée',
    FLOW_RECEIVED: 'Réceptionnée',
    SECTION_ITEMS: 'Lignes',
    SECTION_RECEIVE: 'Réception par lots',
    RECEIVE_HINT:
      'Pour chaque ligne reçue : quantité, n° de lot et date de péremption. Le stock central sera mis à jour (FEFO).',
    COL_MED: 'Médicament',
    COL_ORDERED: 'Commandé',
    COL_RECEIVED: 'Déjà reçu',
    COL_REMAINING: 'Reste',
    COL_TO_RECEIVE: 'Qté reçue',
    COL_LOT: 'N° lot',
    COL_EXPIRY: 'Péremption',
    COL_UNIT_COST: 'Coût unit.',
    ACT_SUBMIT: 'Soumettre',
    ACT_VALIDATE: 'Valider la commande',
    ACT_RECEIVE: 'Enregistrer la réception',
    ACT_CANCEL_ORDER: 'Annuler',
    ACT_CLOSE: 'Fermer',
    RECEIVE_OK: 'Réception enregistrée — stock central mis à jour.',
    RECEIVE_WARN: 'Renseignez au moins une quantité reçue.',
    RECEIVE_LOT_REQUIRED: 'N° de lot et péremption obligatoires pour chaque quantité reçue.',
    CREATE_OK: 'Commande {number} créée.',
    LINES_HINT: 'Ajoutez au moins un médicament avec une quantité.',
    NO_SUPPLIERS: 'Aucun fournisseur actif pour le moment (le champ reste optionnel).',
    CONFIRM_CANCEL: 'Annuler la commande {number} ?',
    SMART_STOCK_LOADING: 'Analyse du stock central…',
    SMART_STOCK_HINT: '{n} référence(s) en stock bas ou rupture sur la centrale.',
    SMART_NO_CENTRAL: 'Pharmacie centrale non configurée — suggestions stock indisponibles.',
    SMART_FILL_ALERTS: 'Remplir depuis alertes',
    SMART_ADD_LABEL: 'Ajouter un médicament',
    SMART_ADD_PLACEHOLDER: 'Rechercher un médicament (nom)…',
    SMART_ADD_CTA: 'Ajouter',
    SMART_NO_MATCH: 'Aucun médicament disponible pour cette recherche.',
    SMART_EMPTY_LINES: 'Recherchez un produit ou remplissez depuis les alertes stock.',
    SMART_NO_STOCK_ROW: 'Hors inventaire site',
    SMART_REMOVE: 'Retirer la ligne',
    SMART_QTY: 'Quantité',
    SMART_COST: 'Coût unit. (Ar)',
    SMART_USE_SUGGEST: 'Utiliser suggestion ({n})',
    SMART_SUGGEST_HINT: 'Suggestion stock : {n}',
    SMART_CATALOG_PRICE: 'Prix catalogue : {n} Ar'
  },

  REQUESTS: {
    BADGE: 'Approvisionnement',
    TITLE: 'Demandes d’approvisionnement',
    DESC_CENTRAL: 'Examinez les demandes des sites, approuvez les quantités puis générez une distribution.',
    DESC_SITE: 'Demandez du réapprovisionnement à la pharmacie centrale selon le stock de votre site.',
    NEW_BUTTON: 'Nouvelle demande',
    STAT_TOTAL: 'Total',
    STAT_PENDING: 'En attente',
    STAT_URGENT: 'Urgentes',
    STAT_TO_DISTRIBUTE: 'À distribuer',
    SEARCH_PLACEHOLDER: 'N° demande, site…',
    SEARCH_ARIA: 'Rechercher une demande',
    FILTER_STATUS_ARIA: 'Filtrer par statut',
    FILTER_ALL: 'Toutes',
    REFRESH_ARIA: 'Actualiser',
    EMPTY: 'Aucune demande pour ce filtre.',
    EMPTY_HINT: 'Créez une demande depuis le stock bas de votre site.',
    COL_NUMBER: 'N°',
    COL_SITE: 'Site',
    COL_PRIORITY: 'Priorité',
    COL_LINES: 'Lignes',
    COL_STATUS: 'Statut',
    COL_DATE: 'Créée le',
    COL_MED: 'Médicament',
    COL_UNIT: 'Unité',
    COL_REQUESTED: 'Demandé',
    COL_APPROVED: 'Approuvé',
    COL_DELIVERED: 'Livré',
    COL_CENTRAL_STOCK: 'Stock centrale',
    COL_TO_APPROVE: 'À approuver',
    COL_SITE_STOCK: 'Stock site',
    COL_MIN: 'Seuil',
    OPEN: 'Ouvrir',
    PRIORITY_NORMAL: 'Normale',
    PRIORITY_URGENT: 'Urgente',
    SECTION_HEADER: 'Demande',
    SECTION_LINES: 'Médicaments demandés',
    FIELD_SITE: 'Site demandeur',
    FIELD_SITE_HINT: 'Défini par votre site de travail actif.',
    FIELD_PRIORITY: 'Priorité',
    FIELD_NOTES: 'Notes',
    FIELD_NOTES_PLACEHOLDER: 'Motif, contexte clinique, remarques…',
    FIELD_REVIEW_NOTES: 'Note de révision',
    LINES_COUNT: '{n} ligne(s)',
    SMART_NO_SITE: 'Choisissez un site de travail pour analyser le stock.',
    SMART_STOCK_LOADING: 'Analyse du stock site…',
    SMART_STOCK_HINT: '{n} référence(s) en stock bas ou rupture sur votre site.',
    SMART_FILL_NEEDS: 'Remplir les besoins',
    SMART_ADD_LABEL: 'Ajouter un médicament',
    SMART_ADD_PLACEHOLDER: 'Rechercher un médicament…',
    SMART_NO_MATCH: 'Aucun médicament trouvé.',
    SMART_ADD_CTA: 'Ajouter',
    SMART_EMPTY_LINES: 'Ajoutez des médicaments ou remplissez automatiquement les besoins.',
    SMART_QTY: 'Qté demandée',
    SMART_REMOVE: 'Retirer la ligne',
    CREATE_TITLE: 'Nouvelle demande d’approvisionnement',
    CREATE_SUBMIT: 'Envoyer la demande',
    CREATE_CANCEL: 'Annuler',
    CREATE_OK: 'Demande {number} envoyée.',
    DETAIL_SITE: 'Site',
    DETAIL_PRIORITY: 'Priorité',
    DETAIL_NOTES: 'Notes',
    DETAIL_REVIEW: 'Note de révision',
    CLOSE: 'Fermer',
    ACT_APPROVE: 'Approuver',
    ACT_REJECT: 'Rejeter',
    ACT_DISTRIBUTE: 'Générer la distribution',
    ACT_CANCEL: 'Annuler la demande',
    ACT_APPROVE_OK: 'Demande approuvée.',
    ACT_REJECT_OK: 'Demande rejetée.',
    ACT_DISTRIBUTE_OK: 'Distribution générée.',
    ACT_CANCEL_OK: 'Demande annulée.',
    FAIL: 'Échec de l’opération.',
    CANNOT_CREATE_CENTRAL:
      'La pharmacie centrale ne crée pas de demande d’appro — utilisez les commandes fournisseurs.',
    STATUS_PENDING: 'En attente',
    STATUS_APPROVED: 'Approuvée',
    STATUS_PARTIALLY_APPROVED: 'Partielle',
    STATUS_REJECTED: 'Rejetée',
    STATUS_FULFILLED: 'Servie',
    STATUS_CANCELLED: 'Annulée'
  },

  MOVEMENTS: {
    BADGE: 'Traçabilité',
    TITLE: 'Mouvements de stock',
    DESC: 'Historique complet des entrées, sorties, transferts, ajustements et dispensations.',
    STAT_TOTAL: 'Mouvements',
    STAT_IN: 'Entrées',
    STAT_OUT: 'Sorties',
    STAT_TRANSFER: 'Transferts',
    STAT_DISPENSE: 'Dispensations',
    STAT_ADJUST: 'Ajustements',
    SEARCH_PLACEHOLDER: 'Médicament, lot, motif, opérateur…',
    SEARCH_ARIA: 'Rechercher un mouvement',
    FILTER_TYPE_ARIA: 'Filtrer par type de mouvement',
    FILTER_ALL: 'Tous',
    TYPE_IN: 'Entrée',
    TYPE_OUT: 'Sortie',
    TYPE_TRANSFER_IN: 'Transfert ↑',
    TYPE_TRANSFER_OUT: 'Transfert ↓',
    TYPE_ADJUSTMENT: 'Ajustement',
    TYPE_DISPENSE: 'Dispensation',
    ADV_TOGGLE: 'Filtres avancés',
    ADV_TOGGLE_ARIA: 'Afficher ou masquer les filtres avancés',
    ADV_EYEBROW: 'Filtres avancés',
    ADV_HINT: 'Affinez par période, site, origine métier ou médicament.',
    ADV_PERIOD: 'Période',
    ADV_FROM: 'Du',
    ADV_TO: 'Au',
    ADV_SITE: 'Site',
    ADV_SITE_ALL: 'Tous les sites',
    ADV_REF: 'Origine',
    ADV_REF_ALL: 'Toutes les origines',
    ADV_MED: 'Médicament',
    ADV_MED_ALL: 'Tous les médicaments',
    ADV_MED_SEARCH: 'Rechercher un médicament…',
    ADV_APPLY: 'Appliquer',
    ADV_RESET: 'Réinitialiser',
    PRESET_TODAY: 'Aujourd’hui',
    PRESET_7D: '7 jours',
    PRESET_30D: '30 jours',
    PRESET_90D: '90 jours',
    PRESET_ALL: 'Toute période',
    REF_ORDER: 'Commande fournisseur',
    REF_DISTRIBUTION: 'Distribution',
    REF_SUPPLY_REQUEST: 'Demande d’appro',
    REF_DISPENSATION: 'Dispensation',
    REF_ADJUSTMENT: 'Ajustement',
    REF_INITIAL: 'Stock initial',
    REF_INVENTORY: 'Inventaire',
    REF_DUTY_CABINET: 'Armoire de garde',
    REFRESH_ARIA: 'Actualiser les mouvements',
    RESULTS_LABEL: 'mouvements',
    PAGE_SIZE: 'Par page',
    PAGE_SIZE_ARIA: 'Nombre de mouvements par page',
    PAGE_OF: 'Page {page} / {pages}',
    PAGE_RANGE: '{from}–{to} sur {total}',
    PREV: 'Précédent',
    NEXT: 'Suivant',
    FIRST: 'Première',
    LAST: 'Dernière',
    EMPTY: 'Aucun mouvement pour ces filtres.',
    EMPTY_HINT: 'Élargissez la période ou effacez les filtres avancés.',
    COL_DATE: 'Date',
    COL_TYPE: 'Type',
    COL_MED: 'Médicament',
    COL_SITE: 'Site',
    COL_LOT: 'Lot',
    COL_QTY: 'Quantité',
    COL_STOCK: 'Stock',
    COL_ACTOR: 'Par',
    COL_REF: 'Origine',
    COL_REASON: 'Motif',
    DETAIL_TITLE: 'Détail du mouvement',
    DETAIL_CLOSE: 'Fermer',
    DETAIL_BEFORE: 'Avant',
    DETAIL_AFTER: 'Après',
    DETAIL_EXPIRY: 'Péremption',
    DETAIL_REF_ID: 'Référence',
    DETAIL_UNIT: 'Unité',
    ACTIVE_FILTERS: '{n} filtre(s) actif(s)'
  },

  DISTRIBUTIONS: {
    BADGE: 'Logistique',
    TITLE: 'Distributions internes',
    DESC: 'Bons de livraison centrale → sites. Chaque ligne précise le lot prélevé ; le stock est transféré à la livraison.',
    NEW_BUTTON: 'Nouvelle distribution',
    SEARCH_PLACEHOLDER: 'Rechercher n° ou site destinataire…',
    SEARCH_ARIA: 'Rechercher une distribution',
    REFRESH_ARIA: 'Actualiser les distributions',
    FILTER_ALL: 'Toutes',
    RESULTS_LABEL: 'distributions',
    STAT_TOTAL: 'Distributions',
    STAT_OPEN: 'En cours',
    STAT_DELIVERED: 'Livrées',
    EMPTY_TITLE: 'Aucune distribution',
    EMPTY_HINT: 'Créez un bon de distribution pour approvisionner un site depuis la centrale.',
    EMPTY_CTA: 'Créer une distribution',
    COL_NUMBER: 'N° distribution',
    COL_DEST: 'Site destinataire',
    COL_LINES: 'Lignes',
    COL_CREATED: 'Créée le',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    OPEN: 'Ouvrir',
    NEXT_PENDING: 'À préparer',
    NEXT_PREPARING: 'À expédier',
    NEXT_SHIPPED: 'À livrer',
    NEXT_DELIVERED: 'Terminée',
    NEXT_CANCELLED: 'Annulée',
    CREATE_TITLE: 'Nouvelle distribution',
    CREATE_DESC:
      'Choisissez le site destinataire, sélectionnez les lots à prélever sur la centrale et indiquez les quantités.',
    SECTION_HEADER: 'En-tête',
    SECTION_LINES: 'Lignes de distribution',
    FIELD_DEST: 'Site destinataire',
    FIELD_DEST_HINT: 'Obligatoire — le stock sera transféré vers ce site à la livraison.',
    FIELD_NOTES: 'Notes',
    LINES_COUNT: '{n} ligne(s)',
    SUBMIT: 'Créer la distribution',
    CANCEL: 'Annuler',
    SAVING: 'Enregistrement…',
    BACK_TO_LIST: 'Retour aux distributions',
    RESULTS_LINES: 'lignes',
    DETAIL_SOURCE: 'Source (centrale)',
    DETAIL_DEST: 'Destination',
    DETAIL_CREATED: 'Créée le',
    DETAIL_DELIVERED: 'Livrée le',
    DETAIL_NOTES: 'Notes',
    FLOW_TITLE: 'Cycle de vie',
    FLOW_PENDING: 'Créée',
    FLOW_PREPARING: 'Préparation',
    FLOW_SHIPPED: 'Expédition',
    FLOW_DELIVERED: 'Livrée',
    SECTION_ITEMS: 'Lignes',
    COL_MED: 'Médicament',
    COL_QTY: 'Quantité',
    COL_LOT: 'Lot prélevé',
    COL_EXPIRY: 'Péremption',
    COL_CENTRAL_STOCK: 'Stock centrale',
    COL_DEST_STOCK: 'Stock site',
    ACT_PREPARE: 'Mettre en préparation',
    ACT_PREPARE_OK: 'Distribution en préparation.',
    ACT_SHIP: 'Marquer expédiée',
    ACT_SHIP_OK: 'Distribution expédiée.',
    ACT_DELIVER: 'Marquer livrée',
    ACT_DELIVER_OK: 'Livrée — stock transféré.',
    ACT_CANCEL: 'Annuler',
    CANCEL_OK: 'Distribution annulée.',
    ACTIONS_HINT: 'Actions sur le bon de distribution',
    EDITABLE_BADGE: 'Modifiable',
    EDIT_HINT: 'Lots et quantités modifiables tant que la distribution n’est pas livrée.',
    EDIT_SAVE: 'Enregistrer les lignes',
    EDIT_RESET: 'Annuler les changements',
    EDIT_UNSAVED: 'Modifications non enregistrées',
    EDIT_OK: 'Lignes de distribution mises à jour.',
    CREATE_OK: 'Distribution {number} créée.',
    LINES_HINT: 'Ajoutez au moins une ligne avec un lot et une quantité.',
    LOT_REQUIRED: 'Choisissez un lot pour chaque ligne.',
    COL_LOT_SELECT: 'Lot centrale',
    COL_LOT_AVAILABLE: 'Dispo lot',
    LOT_SELECT_PLACEHOLDER: '— Choisir un lot —',
    LOT_ALREADY_USED: 'déjà utilisé',
    LOT_PICKER_META: 'Lot {lot} · {qty} dispo · péremption {exp}',
    LOT_FEFO_HINT: 'Lot prioritaire (First Expired, First Out)',
    LOT_QTY_SHORT: 'dispo',
    LOT_NO_EXPIRY: 'Sans date de péremption',
    LOT_SELECT_EMPTY: 'Aucun lot disponible sur la centrale',
    LOT_EXPIRES_IN: 'Expire dans {n} j',
    LOT_EXPIRES_TODAY: 'Expire aujourd’hui',
    LOT_EXPIRED_DAYS: 'Périmé depuis {n} j',
    SMART_ADD_LOT_LABEL: 'Ajouter un lot',
    SMART_LOTS_LOADING: 'Chargement des lots disponibles…',
    SMART_EMPTY_LINES: 'Recherchez un lot ou remplissez depuis les besoins du site.',
    OVER_LOT: 'Max. disponible sur ce lot : {n}',
    DEST_REQUIRED: 'Choisissez un site destinataire.',
    CONFIRM_CANCEL: 'Annuler la distribution {number} ?',
    SMART_STOCK_LOADING: 'Analyse des stocks centrale et site…',
    SMART_NO_CENTRAL: 'Pharmacie centrale non configurée — suggestions stock indisponibles.',
    SMART_SELECT_DEST: 'Sélectionnez un site destinataire pour proposer les besoins du site.',
    SMART_DEST_HINT: '{n} référence(s) en stock bas ou rupture sur le site (disponibles à la centrale).',
    SMART_FILL_NEEDS: 'Remplir besoins site',
    SMART_ADD_LABEL: 'Ajouter un médicament',
    SMART_ADD_PLACEHOLDER: 'Rechercher un médicament ou un n° de lot…',
    SMART_ADD_CTA: 'Ajouter',
    SMART_NO_MATCH: 'Aucun lot disponible à la centrale pour cette recherche.',
    SMART_NO_DEST_ROW: 'Hors inventaire site',
    SMART_REMOVE: 'Retirer la ligne',
    SMART_QTY: 'Quantité',
    OVER_CENTRAL: 'Max. disponible centrale : {n}'
  },

  DISPENSATIONS: {
    BADGE: 'Délivrance',
    TITLE: 'Dispensation patient',
    DESC: 'File d’attente des ordonnances et délivrances manuelles. Contrôle des interactions puis sortie stock site (FEFO).',
    NEW_BUTTON: 'Nouvelle dispensation',
    SEARCH_PLACEHOLDER: 'Rechercher n°, patient…',
    SEARCH_ARIA: 'Rechercher une dispensation',
    REFRESH_ARIA: 'Actualiser les dispensations',
    FILTER_ALL: 'Toutes',
    FILTER_SITE_ARIA: 'Filtrer par site',
    FILTER_SITE_WORK: 'Site de travail',
    FILTER_SITE_ALL: 'Tous les sites',
    FILTER_SOURCE_ALL: 'Toutes origines',
    FILTER_SOURCE_RX: 'Ordonnances médecin',
    FILTER_SOURCE_MANUAL: 'Saisies manuelles',
    RESULTS_LABEL: 'délivrances',
    STAT_TOTAL: 'Délivrances',
    STAT_PENDING: 'En attente',
    STAT_DISPENSED: 'Délivrées',
    STAT_RX_PENDING: 'Ordonnances à traiter',
    EMPTY_TITLE: 'Aucune dispensation',
    EMPTY_HINT: 'Les ordonnances médecin apparaissent ici automatiquement. Vous pouvez aussi créer une délivrance manuelle.',
    EMPTY_RX_HINT: 'Aucune ordonnance médecin en attente sur ce site.',
    EMPTY_CTA: 'Nouvelle dispensation',
    COL_NUMBER: 'N°',
    COL_ORIGIN: 'Origine',
    COL_PATIENT: 'Patient',
    COL_SITE: 'Site',
    COL_CONSULT: 'Consultation',
    COL_LINES: 'Lignes',
    COL_INTERACTION: 'Interaction',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    OPEN: 'Ouvrir',
    TREAT: 'Traiter',
    NEXT_PENDING: 'À délivrer',
    NEXT_DISPENSED: 'Terminée',
    NEXT_CANCELLED: 'Annulée',
    CREATE_TITLE: 'Nouvelle dispensation',
    CREATE_DESC: 'Saisie manuelle — sélectionnez les médicaments disponibles sur le stock du site.',
    SECTION_HEADER: 'Identité patient',
    SECTION_LINES: 'Lignes à délivrer',
    FIELD_SITE: 'Site de délivrance',
    FIELD_PATIENT: 'Patient',
    FIELD_PATIENT_PLACEHOLDER: 'Nom du patient / adhérent',
    FIELD_NOTES: 'Notes',
    FIELD_NOTES_PLACEHOLDER: 'Remarques pharmacien…',
    LINES_COUNT: '{n} ligne(s)',
    SUBMIT: 'Enregistrer la dispensation',
    CANCEL: 'Annuler',
    SAVING: 'Enregistrement…',
    BACK_TO_LIST: 'Retour aux délivrances',
    RESULTS_LINES: 'lignes',
    FLOW_TITLE: 'Cycle de vie',
    FLOW_PENDING: 'En attente',
    FLOW_DISPENSED: 'Délivrée',
    FLOW_CANCELLED: 'Annulée',
    SECTION_ITEMS: 'Médicaments',
    COL_MED: 'Médicament',
    COL_QTY: 'Demandé',
    COL_STOCK: 'Stock site',
    COL_DOSAGE: 'Posologie',
    COL_DOSAGE_PLACEHOLDER: '1 cp x3/j',
    COL_PRICE: 'Prix unit.',
    LINE_TOTAL: 'Sous-total',
    TOTAL_PRICE: 'Total médicaments',
    NO_PRICE: 'Sans tarif',
    PRICE_PARTIAL_HINT: 'Certains médicaments n’ont pas de prix catalogue.',
    COL_LOT: 'Lot prélevé',
    DETAIL_PATIENT: 'Patient',
    DETAIL_SITE: 'Site',
    DETAIL_CREATED: 'Créée le',
    DETAIL_DISPENSED: 'Délivrée le',
    DETAIL_NOTES: 'Notes',
    ACT_DISPENSE: 'Délivrer',
    ACT_DISPENSE_OVERRIDE: 'Délivrer (dérogation)',
    ACT_DISPENSE_OK: 'Médicaments délivrés — stock mis à jour.',
    ACT_CANCEL: 'Annuler',
    CANCEL_OK: 'Dispensation annulée.',
    ACTIONS_HINT: 'Validation pharmacien',
    CREATE_OK: 'Dispensation {number} enregistrée.',
    LINES_HINT: 'Ajoutez au moins un médicament avec une quantité.',
    SITE_REQUIRED: 'Sélectionnez un site de travail.',
    OVERRIDE_LABEL: 'Motif de dérogation (interaction majeure)',
    OVERRIDE_PLACEHOLDER: 'Justification clinique de la délivrance malgré l’interaction…',
    OVERRIDE_MIN: 'Motif requis (min. 5 caractères).',
    INTERACTION_NONE: 'Aucune',
    INTERACTION_OK_DETAIL: 'Aucune interaction détectée',
    INTERACTION_TITLE: 'Interaction {severity} détectée',
    PRINT_SHEET: 'Imprimer A4 / PDF',
    SHEET_ARIA: 'Ordonnance prescrite',
    EDIT_SHEET: 'Modifier l\'ordonnance',
    EDIT_CANCEL: 'Annuler',
    EDIT_SAVE: 'Enregistrer les modifications',
    EDIT_SAVE_OK: 'Ordonnance mise à jour.',
    EDIT_RX_HINT: 'Les modifications sont enregistrées sur l\'ordonnance et la file de dispensation.',
    EDIT_MODE_TITLE: 'Modification ordonnance',
    PANEL_STOCK_TITLE: 'Contrôle stock site',
    PANEL_STOCK_HINT:
      'Quantités demandées vs disponibilité. Lot et date de péremption (FEFO) affichés pour chaque ligne.',
    INTERACTION_BLOCKING_HINT: 'La délivrance nécessitera une dérogation pharmacien.',
    RX_BANNER_TITLE: 'Ordonnance médecin',
    RX_PRESCRIBER: 'Prescrit par Dr {name}',
    RX_TRANSMITTED: 'Transmise depuis une consultation médicale',
    RX_NOTE: 'Note médecin',
    SMART_STOCK_LOADING: 'Chargement du stock site…',
    SMART_STOCK_HINT: 'Seuls les médicaments en stock sur le site sont proposés.',
    SMART_NO_SITE: 'Site de travail requis pour afficher le stock.',
    SMART_ADD_LABEL: 'Ajouter un médicament',
    SMART_ADD_PLACEHOLDER: 'Rechercher un médicament…',
    SMART_NO_MATCH: 'Aucun médicament en stock pour cette recherche.',
    SMART_EMPTY_LINES: 'Recherchez un produit disponible sur le site.',
    SMART_REMOVE: 'Retirer la ligne',
    OVER_STOCK: 'Stock insuffisant (max. {n})'
  },

  ALERTS: {
    BADGE: 'Surveillance',
    TITLE: 'Alertes automatiques',
    DESC: 'Ruptures, stocks bas, lots périmés et péremptions proches — calculés en temps réel sur vos sites.',
    FILTER_SITE_ARIA: 'Filtrer par site',
    FILTER_SITE_WORK: 'Site de travail',
    FILTER_SITE_ALL: 'Tous les sites',
    FILTER_TYPE_ARIA: 'Filtrer par type d’alerte',
    FILTER_ALL: 'Toutes',
    REFRESH_ARIA: 'Actualiser les alertes',
    SEARCH_PLACEHOLDER: 'Rechercher médicament, site, lot…',
    SEARCH_ARIA: 'Rechercher une alerte',
    STAT_TOTAL: 'Total alertes',
    STAT_OUT: 'Ruptures',
    STAT_LOW: 'Stocks bas',
    STAT_EXPIRED: 'Périmés',
    STAT_EXPIRING: 'Péremption proche',
    CHART_TYPE_PIE_TITLE: 'Répartition par type',
    CHART_TYPE_PIE_DESC: 'Camembert des alertes actives sur le périmètre sélectionné.',
    CHART_TYPE_BAR_TITLE: 'Volume par type',
    CHART_TYPE_BAR_DESC: 'Histogramme vertical — comparaison rapide des catégories.',
    CHART_SITE_BAR_TITLE: 'Alertes par site',
    CHART_SITE_BAR_DESC: 'Sites les plus concernés sur la période courante.',
    CHART_MED_BAR_TITLE: 'Médicaments les plus signalés',
    CHART_MED_BAR_DESC: 'Produits avec le plus d’alertes cumulées.',
    CHART_AXIS_COUNT: 'Nombre d’alertes',
    CHART_AXIS_SITE: 'Site',
    CHART_AXIS_TYPE: 'Type',
    CHART_AXIS_MED: 'Médicament',
    EMPTY_TITLE: 'Aucune alerte',
    EMPTY_HINT: 'Tout est sous contrôle sur ce périmètre. Les ruptures et péremptions apparaîtront ici automatiquement.',
    EMPTY_CHART: 'Aucune donnée à afficher.',
    UNAVAILABLE: 'Alertes indisponibles.',
    LOADING: 'Chargement des alertes…',
    TYPE_OUT_OF_STOCK: 'Rupture',
    TYPE_LOW_STOCK: 'Stock bas',
    TYPE_EXPIRED: 'Périmé',
    TYPE_EXPIRING: 'Péremption proche',
    COL_TYPE: 'Type',
    COL_MED: 'Médicament',
    COL_SITE: 'Site',
    COL_DETAIL: 'Détail',
    COL_SEVERITY: 'Gravité',
    SEVERITY_CRITICAL: 'Critique',
    SEVERITY_WARNING: 'Attention',
    RESULTS_LABEL: 'alertes',
    CENTRAL_SUFFIX: ' (centrale)'
  },

  INVENTORY: {
    BADGE: 'Comptage',
    TITLE: 'Inventaires',
    DESC: 'Session de comptage physique par site (y compris l’armoire de garde). Les lots non comptés restent inchangés à la clôture.',
    DESC_WORK: 'Comptage des lots de votre site de travail. Un seul inventaire ouvert à la fois.',
    NEW_BUTTON: 'Ouvrir un inventaire',
    REFRESH_ARIA: 'Actualiser les inventaires',
    SEARCH_PLACEHOLDER: 'N° session, site…',
    SEARCH_ARIA: 'Rechercher un inventaire',
    FILTER_STATUS_ARIA: 'Filtrer par statut',
    FILTER_ALL: 'Tous',
    STAT_TOTAL: 'Sessions',
    STAT_OPEN: 'En cours',
    STAT_CLOSED: 'Clôturés',
    RESULTS_LABEL: 'sessions',
    EMPTY_TITLE: 'Aucun inventaire',
    EMPTY_HINT: 'Ouvrez une session pour photographier le stock théorique, puis saisissez les quantités physiques.',
    EMPTY_CTA: 'Ouvrir un inventaire',
    NO_WORK_SITE: 'Sélectionnez un site de travail pour inventorier.',
    COL_NUMBER: 'N° session',
    COL_SITE: 'Site',
    COL_PROGRESS: 'Comptage',
    COL_STARTED: 'Ouvert le',
    COL_STATUS: 'Statut',
    COL_ACTIONS: 'Actions',
    OPEN: 'Ouvrir',
    PROGRESS: '{counted} / {total}',
    NEXT_COUNTING: 'Comptage en cours',
    NEXT_CLOSED: 'Stock mis à jour',
    NEXT_CANCELLED: 'Sans effet sur le stock',
    BANNER_OPEN: 'Inventaire en cours — {number}',
    BANNER_RESUME: 'Reprendre le comptage',
    FLOW_TITLE: 'Étapes de l’inventaire',
    FLOW_OPEN: 'Cliché',
    FLOW_COUNT: 'Comptage',
    FLOW_CLOSE: 'Clôture',
    PROGRESS_LABEL: '{counted} / {total} lots',
    PROGRESS_PCT: '{n} %',
    MATCH_THEO: 'Reporter',
    MATCH_ARIA: 'Reporter la quantité système pour {name}',
    KEYBOARD_HINT: 'Entrée ou ↓ : ligne suivante · ↑ : précédente',
    CLOSE_TITLE: 'Clôturer l’inventaire',
    CLOSE_LEAD: 'Le stock du site inventorié sera mis à jour selon les quantités physiques saisies.',
    CLOSE_UNCOUNTED_HINT: 'Les lots non comptés restent inchangés.',
    CLOSE_READY: 'Tous les lots comptés seront appliqués au stock.',
    CLOSE_APPLY: 'Clôturer et appliquer',
    CANCEL_TITLE: 'Annuler l’inventaire',
    CANCEL_LEAD: 'Aucune quantité ne sera écrite en stock. Le cliché sera perdu.',
    CANCEL_APPLY: 'Confirmer l’annulation',
    CREATE_TITLE: 'Nouvel inventaire',
    CREATE_DESC:
      'Choisissez le site (ou l’armoire de garde) : un cliché des lots est pris maintenant, le comptage se fait ensuite.',
    CREATE_SNAPSHOT:
      'Le stock théorique sera photographié à l’ouverture — un seul inventaire ouvert à la fois par site.',
    FIELD_NOTES_PLACEHOLDER: 'Zone, équipe, remarque de tournée…',
    FIELD_SITE: 'Site',
    FIELD_SITE_HINT: 'Un seul inventaire ouvert à la fois par site (armoire comprise).',
    FIELD_LOCATION: 'Lieu de stock',
    FIELD_LOCATION_HINT: 'Sur le site central, inventoriez séparément la pharmacie et l’armoire de garde.',
    LOCATION_MAIN: 'Pharmacie (stock principal)',
    LOCATION_DUTY: 'Armoire de garde',
    LOCATION_MAIN_SHORT: 'Pharmacie',
    LOCATION_DUTY_SHORT: 'Armoire',
    FIELD_NOTES: 'Notes (facultatif)',
    CREATE_SUBMIT: 'Ouvrir la session',
    CREATE_CANCEL: 'Annuler',
    CREATE_CONFIRM:
      'Ouvrir un inventaire sur « {site} » ? Un cliché des lots actuels sera pris.',
    CREATE_OK: 'Inventaire ouvert.',
    CREATE_SITE_REQUIRED: 'Choisissez un site.',
    FAIL: 'Échec de l’opération.',
    DETAIL_BADGE: 'Session',
    BACK: 'Retour aux inventaires',
    META_SITE: 'Site',
    META_LOCATION: 'Lieu de stock',
    META_STARTED: 'Ouvert le',
    META_CLOSED: 'Clôturé le',
    META_AUTHOR: 'Ouvert par',
    META_CLOSER: 'Clôturé par',
    META_NOTES: 'Notes',
    COL_LOCATION: 'Lieu',
    STAT_LINES: 'Lots',
    STAT_COUNTED: 'Comptés',
    STAT_UNCOUNTED: 'Non comptés',
    STAT_VAR: 'Écarts',
    STAT_SURPLUS: 'Surplus',
    STAT_SHORTAGE: 'Manquants',
    SEARCH_LINES: 'Médicament, lot…',
    SEARCH_LINES_ARIA: 'Rechercher une ligne d’inventaire',
    FILTER_LINES_ARIA: 'Filtrer les lignes',
    FILTER_LINES_ALL: 'Toutes',
    FILTER_UNCOUNTED: 'Non comptées',
    FILTER_VARIANCE: 'Écarts',
    COL_MED: 'Médicament',
    COL_LOT: 'Lot',
    COL_EXPIRY: 'Péremption',
    COL_THEO: 'Système',
    COL_COUNTED: 'Physique',
    COL_VAR: 'Écart',
    COL_UNIT: 'Unité',
    NEW_LOT_TAG: 'Lot trouvé',
    UNCOUNTED: 'À compter',
    SAVE: 'Enregistrer',
    SAVE_OK: 'Comptage enregistré.',
    DIRTY: 'Modifications non enregistrées',
    EXPORT: 'Exporter',
    IMPORT: 'Importer',
    IMPORT_OK: '{n} ligne(s) importée(s).',
    IMPORT_EMPTY: 'Aucune quantité à importer (colonne qte_comptee vide).',
    ADD_LOT: 'Lot trouvé',
    ADD_LOT_TITLE: 'Ajouter un lot trouvé',
    ADD_LOT_DESC: 'Lot présent physiquement mais absent du cliché — il sera créé à la clôture s’il n’existe pas encore.',
    FIELD_MED: 'Médicament',
    FIELD_MED_SEARCH: 'Nom, catégorie, unité…',
    FIELD_MED_HINT: 'Recherche insensible aux accents — tapez « paracetamol 500 ».',
    FIELD_MED_EMPTY: 'Tapez pour filtrer le catalogue.',
    FIELD_MED_NO_MATCH: 'Aucun médicament ne correspond à cette recherche.',
    FIELD_MED_CHANGE: 'Changer',
    FIELD_MED_CHOOSE: 'Choisir',
    FIELD_LOT: 'N° de lot',
    FIELD_EXPIRY: 'Péremption',
    FIELD_QTY: 'Quantité physique',
    FIELD_QTY_HINT: 'Unités réellement présentes.',
    ADD_LOT_SUBMIT: 'Ajouter',
    ADD_LOT_OK: 'Lot ajouté.',
    CLOSE: 'Clôturer',
    CLOSE_CONFIRM:
      'Clôturer {number} ? {counted} ligne(s) comptée(s), {uncounted} non comptée(s) (inchangées), {variances} écart(s). Le stock sera mis à jour.',
    CLOSE_OK: 'Inventaire clôturé — stock mis à jour.',
    CANCEL: 'Annuler l’inventaire',
    CANCEL_CONFIRM: 'Annuler {number} ? Aucun stock ne sera modifié.',
    CANCEL_OK: 'Inventaire annulé.',
    EMPTY_LINES: 'Aucun lot en stock sur ce lieu au moment de l’ouverture. Ajoutez un lot trouvé si besoin.',
    MED_TOTAL_HINT: 'Total système ({lots} lots) : {qty}',
    LOT_OF_HINT: 'Lot {n}/{total}',
    EMPTY_FILTER: 'Aucune ligne ne correspond aux filtres.',
    INVALID_QTY: 'Quantité invalide.',
    LOADING: 'Chargement de l’inventaire…',
    NOT_FOUND: 'Inventaire introuvable.'
  },

  REPORTS: {
    BADGE: 'Analyse',
    TITLE: 'Rapports pharmacie',
    DESC: 'Synthèse des délivrances, valeur des ordonnances et classement des médicaments prescrits.',
    TAB_SYNTHESIS: 'Synthèse',
    TAB_PRESCRIPTIONS: 'Ordonnances',
    TAB_MEDICATIONS: 'Médicaments',
    FILTERS_EYEBROW: 'Filtres',
    FILTERS_HINT: 'Période, site, société et statut de délivrance.',
    FILTER_BAR_ARIA: 'Filtres du rapport pharmacie',
    FILTER_PERIOD: 'Raccourcis de période',
    FILTER_DATE_FROM: 'Du',
    FILTER_DATE_TO: 'Au',
    FILTER_SITE_SHORT: 'Site',
    FILTER_ALL_SITES: 'Tous les sites',
    FILTER_SITE_ARIA: 'Filtrer par site',
    FILTER_COMPANY_SHORT: 'Société',
    FILTER_ALL_COMPANIES: 'Toutes les sociétés',
    FILTER_COMPANY_ARIA: 'Filtrer par société',
    FILTER_STATUS_ARIA: 'Statut délivrance',
    FILTER_STATUS_SHORT: 'Statut',
    FILTER_STATUS_ALL: 'Toutes',
    FILTER_STATUS_DISPENSED: 'Délivrées',
    FILTER_STATUS_PENDING: 'En attente',
    PRESET_7D: '7 jours',
    PRESET_30D: '30 jours',
    PRESET_90D: '90 jours',
    PRESET_12M: '12 mois',
    REFRESH_LABEL: 'Actualiser',
    REFRESH_ARIA: 'Actualiser le rapport',
    LOADING: 'Chargement du rapport…',
    UNAVAILABLE: 'Rapport indisponible.',
    STAT_DISPENSATIONS: 'Ordonnances / délivrances',
    STAT_LINES: 'Lignes médicaments',
    STAT_TOTAL_AMOUNT: 'Montant total',
    STAT_AVG_VALUE: 'Valeur moyenne ordonnance',
    STAT_RX: 'Ordonnances médecin',
    STAT_MANUAL: 'Saisies manuelles',
    STAT_MEDS: 'Médicaments distincts',
    CHART_ORIGIN_TITLE: 'Origine des délivrances',
    CHART_ORIGIN_DESC: 'Répartition ordonnances médecin vs saisies pharmacie.',
    CHART_TOP_MED_TITLE: 'Médicaments les plus prescrits',
    CHART_TOP_MED_DESC: 'Classement par nombre d’ordonnances sur la période.',
    CHART_TOP_MED_DESC_QTY: 'Classement par quantité totale prescrite sur la période.',
    CHART_LEAST_MED_TITLE: 'Médicaments les moins prescrits',
    CHART_LEAST_MED_DESC: 'Produits avec le moins d’occurrences (parmi ceux prescrits).',
    CHART_LEAST_MED_DESC_QTY: 'Produits avec la plus faible quantité prescrite (parmi ceux prescrits).',
    CHART_STOCK_TITLE: 'Top médicaments en stock',
    CHART_STOCK_DESC: 'Répartition des plus gros stocks. Cliquez une part ou une quantité pour voir les lots.',
    CHART_STOCK_TOTAL: 'Total unités',
    CHART_STOCK_VALUE: 'Valeur totale',
    CHART_STOCK_UNITS_SHORT: 'Unités',
    CHART_STOCK_OTHERS: 'Autres',
    CHART_STOCK_SHARE: 'Part',
    CHART_STOCK_HINT: 'Survolez une part pour voir les valeurs, cliquez pour le détail des lots.',
    CHART_AXIS_STOCK: 'Unités en stock',
    COL_ON_HAND: 'En stock',
    COL_LOT: 'Lot',
    COL_EXPIRY: 'Péremption',
    COL_SITE: 'Site',
    EMPTY_STOCK: 'Aucun stock disponible pour ce filtre.',
    EMPTY_STOCK_LOTS: 'Aucun lot actif pour ce médicament.',
    STOCK_DETAIL_TITLE: 'Détail stock',
    STOCK_DETAIL_STATS_ARIA: 'Synthèse stock médicament',
    STOCK_DETAIL_CLOSE: 'Fermer',
    STOCK_OPEN_ARIA: 'Voir le stock de {name}',
    STOCK_OPEN_QTY_ARIA: 'Voir les lots de {name} ({qty} unités)',
    STOCK_OPEN_VALUE_ARIA: 'Voir les lots de {name} — valeur {value}',
    STOCK_LOTS_LOADING: 'Chargement des lots…',
    STOCK_LOTS_ERROR: 'Impossible de charger les lots.',
    STOCK_GO_TO_STOCK: 'Voir le stock',
    CHART_AXIS_COUNT: 'Ordonnances',
    CHART_AXIS_QTY: 'Quantité prescrite',
    CHART_AXIS_MED: 'Médicament',
    METRIC_ARIA: 'Indicateur des histogrammes',
    METRIC_RX: 'Ordonnances',
    METRIC_QTY: 'Quantités',
    MED_CHART_HINT: 'Cliquez une barre ou un nombre pour voir les ordonnances concernées.',
    MED_TABLE_HINT: 'Cliquez une ligne ou un nombre pour le détail.',
    MED_DETAIL_TITLE: 'Détail médicament',
    MED_DETAIL_STATS_ARIA: 'Synthèse médicament',
    MED_DETAIL_EMPTY: 'Aucune ordonnance liée à ce médicament sur la période.',
    MED_DETAIL_CLOSE: 'Fermer',
    MED_OPEN_ARIA: 'Voir les ordonnances de {name}',
    MED_OPEN_RX_ARIA: 'Voir les ordonnances contenant {name}',
    MED_OPEN_QTY_ARIA: 'Voir les quantités prescrites de {name}',
    MED_OPEN_DISPENSATION: 'Ouvrir',
    PRESCRIPTIONS_AVG: 'Valeur moyenne par ordonnance',
    PRESCRIPTIONS_LINES: 'lignes médicaments',
    PRESCRIPTIONS_COUNT: 'ordonnances',
    MEDS_COUNT: 'médicament(s)',
    ORIGIN_RX: 'Médecin',
    ORIGIN_MANUAL: 'Pharmacie',
    PAGE_SIZE: 'Par page',
    PAGE_SIZE_ARIA: 'Nombre d’ordonnances par page',
    PAGE_PREV: 'Précédent',
    PAGE_NEXT: 'Suivant',
    PAGE_OF: 'Page {page} / {pages}',
    PAGE_RANGE: '{from}–{to} sur {total} ordonnances',
    PAGE_TOTALS_ARIA: 'Totaux des ordonnances de la page',
    RX_TOTAL_LABEL: 'Total ordonnance',
    NO_PRICE_HINT: 'Certains médicaments n’ont pas de prix catalogue — montants partiels.',
    COL_DATE: 'Date',
    COL_NUMBER: 'N° ordonnance',
    COL_PATIENT: 'Nom, prénom et matricule',
    COL_COMPANY: 'Société',
    COL_MED: 'Médicaments prescrits',
    COL_QTY: 'Qté',
    COL_UNIT_PRICE: 'Prix unitaire',
    COL_AMOUNT: 'Montant',
    COL_RX_COUNT: 'Ordonnances',
    COL_TOTAL_QTY: 'Quantité totale',
    EMPTY_PRESCRIPTIONS: 'Aucune ordonnance sur la période sélectionnée.',
    EMPTY_MEDICATIONS: 'Aucun médicament prescrit sur la période.',
    NO_PRICE: '—',
    RESULTS_LABEL: 'lignes'
  }
};

export const PHARMACY_STATUS_VARIANT = {
  DRAFT: 'secondary',
  PENDING: 'warning',
  VALIDATED: 'info',
  RECEIVED: 'success',
  CANCELLED: 'secondary',
  APPROVED: 'info',
  PARTIALLY_APPROVED: 'warning',
  REJECTED: 'danger',
  FULFILLED: 'success',
  PREPARING: 'info',
  SHIPPED: 'primary',
  DELIVERED: 'success',
  DISPENSED: 'success',
  COUNTING: 'warning',
  CLOSED: 'success'
};

export const SEVERITY_VARIANT = {
  NONE: 'success',
  MINOR: 'info',
  MODERATE: 'warning',
  MAJOR: 'danger'
};

export const STOCK_STATUS_VARIANT = {
  OK: 'success',
  LOW_STOCK: 'warning',
  OUT_OF_STOCK: 'danger'
};

export const statusLabel = (s) => PHARMACY_COPY.STATUS[s] || s || '—';
export const severityLabel = (s) => PHARMACY_COPY.SEVERITY[s] || s || '—';
export const stockStatusLabel = (s) => PHARMACY_COPY.STOCK_STATUS[s] || s || '—';

export const inventoryLocationLabel = (location, { short = false } = {}) => {
  const loc = String(location || 'MAIN').toUpperCase();
  const copy = PHARMACY_COPY.INVENTORY;
  if (loc === 'DUTY') return short ? copy.LOCATION_DUTY_SHORT : copy.LOCATION_DUTY;
  return short ? copy.LOCATION_MAIN_SHORT : copy.LOCATION_MAIN;
};

/** Rôles ayant accès aux fonctions centrales (gestion). */
export const CENTRAL_ROLES = [ROLES.ADMIN, ROLES.ADMIN_PHARMACIST];
